import { getHome, getUsers } from '#/apis/auth.js';
import { userStore } from '#/stores/user.svelte.js';

/**
 * 서버에서 최신 사용자 정보를 가져와 userStore에 반영한다.
 * 토큰이 유효하지 않으면 status 401을 담은 에러를 던진다.
 * @returns {Promise<Object<string, any>>}
 */
export async function hydrateUserSession() {
	const result = await getHome();
	let user = result.user;

	if (!user.color) {
		try {
			const { users } = await getUsers();
			const me = users.find((u) => u._id === user._id);
			if (me?.color) user = { ...user, color: me.color };
		} catch (_) {
			// color 조회 실패는 무시
		}
	}

	userStore.set(user);
	return user;
}
